import ReAuthModal from "./components/modals/ReAuthModal";

const modals = [
  {
    name: "re-auth-modal",
    element: ReAuthModal,
  },
];

export default modals;
